export const ROLES = {
  SUPER_ADMIN: 'superAdmin',
  SALES: 'sales',
  OWNER: 'owner',
  USER_ADMIN: 'FEuserAdmin',
}